import { handleActions } from 'redux-actions';
import {
  blacklineSourceGuidListLoading,
  blacklineSourceGuidListLoaded,
  blacklineSourceGuidListError,
  resetBlacklineGuidList,
} from 'store/actions/blackline-view-actions';
import { BlacklineGuidList } from 'models/api/blackline-guid-list-api-model';

export default handleActions(
  {
    [blacklineSourceGuidListLoading]: (blacklineList) => {
      return blacklineList.setLoading();
    },
    [blacklineSourceGuidListLoaded]: (blacklineList, { payload }) => {
      return blacklineList.setLoaded(payload);
    },
    [blacklineSourceGuidListError]: (blacklineList, { payload }) => {
      return blacklineList.setError(payload);
    },
    [resetBlacklineGuidList]: () => {
      return new BlacklineGuidList();
    },
  },
  new BlacklineGuidList(),
);
